import { useTranslation } from "react-i18next"
import { Link } from "react-router"
import { MonitorIcon } from "lucide-react"

import { Button } from "@/components/ui/button"

/**
 * PDD §11.6's "every other screen" branded state: a deliberate limitation,
 * not a cramped, half-broken form. Rendered by the router itself
 * (`app/router.tsx`) in place of any route not marked `phoneSafe` on a
 * phone-width viewport, so no individual screen has to remember to check
 * `useIsMobile()` on its own.
 */
export function RequiresLargerScreen() {
  const { t } = useTranslation("common")
  return (
    <div className="flex flex-col items-center gap-3 px-6 py-16 text-center">
      <div className="text-muted-foreground" aria-hidden>
        <MonitorIcon className="size-10" />
      </div>
      <h1 className="text-base font-medium">{t("responsive.title")}</h1>
      <p className="max-w-sm text-sm text-muted-foreground">{t("responsive.body")}</p>
      <Button asChild variant="outline" className="min-h-11">
        <Link to="/">{t("responsive.backToOverview")}</Link>
      </Button>
    </div>
  )
}
